module.exports = __webpack_public_path__ + "img/P6-en.32b70f3e.png";